import React, { useState } from 'react';
import FormulaireGabarit from './ProfilGabarit/FormulaireGabarit/FormulaireGabarit';
import ProfilGabarit from './ProfilGabarit/ProfilGabarit';
import TableauGabarit from './TableauGabarit/TableauGabarit';
import AccesRestreins from 'hoc/AccesRestreins/AccesRestreins';
import { RiAddCircleLine } from 'react-icons/ri';
import { checkMot } from 'ressources/functionJS/checkMot';
import * as indexConteneurInfo from 'ressources/glossaires/glossaire_conteneur_info';
import * as privilege from 'ressources/glossaires/glossaire_privileges';
import * as s from 'ressources/StyleGlobal/StyleGlobal';
import styles from './Gabarit.module.scss';

const Gabarit = (props) => {
  const [infoSelect, setInfoSelect] = useState(null);
  const [iConteneurInfo, setIConteneurInfo] = useState(0);

  const selectioneLigne = (ligne) => {
    setInfoSelect(ligne);
    setIConteneurInfo(indexConteneurInfo.profil);
  };
  //fonction pour ouverture du conteneur information avec le formulaire de création
  const creerGabarit = () => {
    setIConteneurInfo(indexConteneurInfo.ajouterForm);
  };

  return (
    <div className={[s.row, styles.comtnet].join(' ')}>
      <div className={s.col_sm_6}>
        <div className={styles.fontSize}>{checkMot('liste_des_gabarits')}</div>
        <AccesRestreins
          listNumPrivilege={[
            privilege.creer_des_gabarits,
            privilege.modifier_des_gabarits,
            privilege.supprimer_des_gabarits,
          ]}
        >
          <TableauGabarit selectioneLigne={selectioneLigne} />
        </AccesRestreins>
        <AccesRestreins numPrivilege={privilege.creer_des_gabarits}>
          <button onClick={creerGabarit} className={styles.btadd}>
            <RiAddCircleLine size={34} />
            {checkMot('creer_un_gabarit')}
          </button>
        </AccesRestreins>
      </div>
      <div className={s.col_sm_6}>
        {iConteneurInfo === indexConteneurInfo.ajouterForm ? (
          <span style={{ display: 'block' }}>
            <FormulaireGabarit />
          </span>
        ) : iConteneurInfo === indexConteneurInfo.profil ? (
          <ProfilGabarit
            infoSelect={infoSelect}
            reqModifier={props.reqModifier}
            reqSupprimer={props.reqSupprimer}
          />
        ) : (
          <div className={styles.fontSize}>
            {checkMot('selectionne_un_gabarit')}
          </div>
        )}
      </div>
    </div>
  );
};

export default Gabarit;
